import fetch from './index'
export default {
    async rApi(url, data, isGet = false) {
        if (!data) {
            data = {}
        }
        return fetch({
            url: url,
            isGet: isGet,
            data
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/common.js